import React from "react";
import { Box, Stack, Typography, useTheme } from "@mui/material";
import Icon from "../Icon";
import "./IconHeader.scss";
import { EGButton } from "../../MainComponents/Button/EGButton/EGButton";

export const IconHeader = ({
  iconName = "",
  title = "",
  button = false,
  buttonAction = () => {},
  iconButtonName = "",
  fontSize = 12,
  variant = "h5",
  fontWeight = 600,
  uppercase = true,
  ...rest
}) => {
  const theme = useTheme();
  return (
    <Stack
      display="flex"
      alignItems="center"
      justifyContent="space-evenly"
      flexDirection="row"
      spacing={1.5}
      padding={0}
    >
      {iconName && (
        <Box className="icon-Header">
          <Icon
            name={iconName}
            color={theme.palette.secondary.main}
            size={24}
          />
        </Box>
      )}
      <Typography
        variant={variant}
        color="primary"
        fontSize={fontSize}
        fontWeight={fontWeight}
      >
        {uppercase ? title.toLocaleUpperCase() : title}
      </Typography>
      <Box
        sx={{
          flexGrow: 1,
          borderBottom: `2px solid ${theme.palette.primary.main}`,
        }}
      />
      {button && (
        <EGButton
          iconName={iconButtonName}
          onClick={typeof buttonAction === "function" ? buttonAction : () => {}}
          sx={{
            padding: 0,
            minWidth: 30,
            maxWidth: 30,
          }}
        />
      )}
    </Stack>
  );
};
